import { Box } from '@mantine/core'
import React, { useState } from 'react'
import { Modal } from 'components/Modal'
import { MODAL_MAX_WIDTH } from 'Theme'

export const CustomizationRequestFormModal = ({
  trigger,
}: {
  trigger: React.ReactNode
}) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <Box display="inline" onClick={() => setIsOpen(true)}>
        {trigger}
      </Box>
      <Modal
        ariaLabel="Customization request form"
        isOpen={isOpen}
        maxWidth={MODAL_MAX_WIDTH.PX_720}
        onModalClose={() => setIsOpen(false)}
        isWithFooter={false}
      >
        <Box w="100%" mih="400px" h="80vh">
          <iframe
            className="airtable-embed"
            src="https://airtable.com/embed/appZfIYioHJPfcJmX/pagi8ZFbN45jitFDA/form"
            title="airtable form"
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </Box>
      </Modal>
    </>
  )
}
